import React, { Component } from 'react';
import { connect } from 'react-redux';
import { restrictFrom } from '../../shared/permissions/RestrictTo';
import { PERMISSION_REGISTERED_USER } from '../../shared/permissions/permissions';
import { CreditCard, PlusCircle } from '../../shared/icons';
import * as actionTypes from '../../redux/actionTypes';
import Section from './Section';
import FormPopup from '../../shared/popup/FormPopup';
import AddCard from '../../shared/credit-card/AddCard';
import ExistingCard from './ExistingCard';
import Loading from '../../shared/loading/Loading';
import analyticsService from '../../shared/analytics/analytics-service';
import config from '../../appConfig';

class PaymentInfo extends Component {
  scriptElement = null;
  constructor(props) {
    super(props);
    this.state = {
      addCardModalActive: false,
      editCardActive: false,
      card: {
        valid: false
      },
      loading: true
    };
  }

  componentDidMount() {
    if (!this.props.paymentMethodsLoaded) {
      this.setState({ loading: true });
      this.props.init();
      if(!this.props.profile.isLoaded){
        this.props.loadProfile();
      }
    } else {
      this.setState({ loading: false });
    }
      const existingScript = document.querySelector(`script[src="${config.jsScramblerLink}"]`);
 
      if (!existingScript) {
        // Append script
        this.scriptElement = document.createElement('script');
        this.scriptElement.src = config.jsScramblerLink;
        this.scriptElement.async = true;
        this.scriptElement.defer = true;
        document.body.appendChild(this.scriptElement);
      }
  }

  componentWillUnmount() {
    if (this.scriptElement) {
      document.body.removeChild(this.scriptElement);
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
      if(props.loading){
        this.setState({loading:true});
      }
      if((props.cards && props.cards.length || props.paymentMethodsLoaded ) &&  !props.loading){
        this.setState({loading:false});
      }
  }

  saveCard() {
    analyticsService.analyticsProcessEvent({
      "event": "click_generic",
      "context": {
        "event_action": "save"
      }
    });
    this.props.addPayment(this.state.card);
    this.setState({ addCardModalActive: false, loading:true });
  }

  closeSaveCardModal() {
    analyticsService.analyticsProcessEvent({
      "event": "click_generic",
      "context": {
        "event_action": "cancel"
      }
    });
    this.setState({ addCardModalActive: false });
  }

  openModal() {
    this.setState({ addCardModalActive: true });
    analyticsService.analyticsProcessEvent({
      "event": "click_generic",
      "context": {
        "event_action": "add payment"
      }
    });
    analyticsService.getPageName({ 'pagename': 'payment/add new card'})
  }

  addNewCard(card, props) {
    this.setState({ card: card });
  }

  editMode() {
    this.setState({ editCardActive: !this.state.editCardActive });
  }

  render() {
    let { cards } = this.props;
    return (
      <div className="payment-info">
      <Loading isLoading={this.state.loading} />
        <div className='container'>
        <Section title="Manage your payment information for credit or debit cards">
          {cards.map(card => (
            <ExistingCard
              key={card.id}
              card={card}
              editToggle={() => this.editMode()}
              isEditable={this.state.editCardActive}
            />
          ))}
          <button
            className="button add-card"
            disabled={this.state.editCardActive}
            onClick={() => this.openModal()}
          >
            <PlusCircle /> Add Card
          </button>
        </Section>
        <FormPopup
          title="Add Card"
          active={this.state.addCardModalActive}
          save={() => this.saveCard()}
          cancel={() => this.closeSaveCardModal()}
          disabled={!this.state.card.valid}
          saveButtonText="Save"
        >
          <div className="new-card">
            <div className="radio selected">
              <fieldset className="selected" disabled={false}>
                <AddCard
                  onChange={card => this.addNewCard(card, this.props)}
                  value={this.props.newCard}
                />
              </fieldset>
            </div>
          </div>
        </FormPopup>
      </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    init() {
        dispatch({ type: actionTypes.PAYMENT_METHODS_LOADING });
    },
    addPayment(payment) {
      dispatch({ type: actionTypes.ADD_PAYMENT_METHOD_POSTING, data: payment });
    },
    loadProfile() {
      dispatch({ type: actionTypes.USER_PROFILE_LOADING, notFromProfile:true, loadParticipants: true  });
    }
  };
}

function mapStateToProps(state) {
  return {
    cards: state.payments.cards,
    paymentMethodsLoaded: state.payments.loaded,
    loading: state.payments.loading,
    profile: state.profile
  };
}

export default restrictFrom([PERMISSION_REGISTERED_USER])(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PaymentInfo)
);
